<div class="w-full flex flex-col items-center mt-[120px]">
    <img src="images/landing/case-studies.svg" alt="case studies" class="h-[40px]" />
    <div class="mt-[14px] px-4 sm:px-[10%] text-center text-sm sm:text-base">
        Dive deep into some our best work. See just a few of the apps we've successfully built and marketed with our
        in-house
        tools and expertise.
    </div>
    <div class="mt-[40px] pb-[190px] flex items-center justify-center col">
        <img src="images/landing/case-studies/development.avif" alt="development" class="h-[300px] cursor-pointer"
            routerLink="development-case-studies" />
        <img src="images/landing/case-studies/marketing.avif" alt="marketing" class="h-[300px] cursor-pointer"
            routerLink="marketing-case-studies" />
    </div>
</div>